import { create } from "zustand";

interface SessionExpiredState {
  isExpired: boolean;
  message: string;
  showModal: () => void;
  hideModal: () => void;
  setExpired: (message?: string) => void;
}

/**
 * Global store for managing session expiration state.
 * This is used by the API layer to trigger the session expired modal
 * when a 401 Unauthorized response is received.
 */
export const useSessionExpiredStore = create<SessionExpiredState>((set) => ({
  isExpired: false,
  message: "Your session has expired. Please log in again to continue.",
  
  showModal: () => set({ isExpired: true }),
  
  hideModal: () => set({ isExpired: false }),
  
  setExpired: (message) =>
    set({
      isExpired: true,
      message:
        message ||
        "Your session has expired. Please log in again to continue.",
    }),
}));
